import React, { useState, useEffect } from "react";
import "../../members/screens/MemberPrint.css";
import { PhotoTable } from "../../../components/ui/TablePrintFormat";
import { BASE_URL } from "../../../env";
import { calculateEmiAmountRaw } from "../../../utils/utils";

const JlgGeneratedEmiSchedule = (memberDetails) => {
  const [generatedSchedule, setGeneratedSchedule] = useState([]);
  const [totalInterest, setTotalInterest] = useState(0);

  useEffect(() => {
    handleGenerateSchedule(); // Call the function to generate the schedule
  }, []);

  const handleGenerateSchedule = () => {
    const expectedLoanAmount =
      memberDetails.memberDetails.memberDetails
        .sanctionedLoanAmountBySanctionCommittee ||
      memberDetails.memberDetails.proposedLoanDetails.loanAmount;
    const rateOfInterest =
      memberDetails.memberDetails.proposedLoanDetails.rateOfInterest;
    const tenureInMonths =
      memberDetails.memberDetails.proposedLoanDetails.tenureInMonths;
    const dayOrderByBranchManager =
      memberDetails.memberDetails.center.bmMeetingDayOrder;

    const monthlyRate = rateOfInterest / 12 / 100;
    const emi = calculateEmiAmountRaw(expectedLoanAmount, rateOfInterest, tenureInMonths);

    let balance = expectedLoanAmount;
    let beginingBalance = balance;
    let sumOfInterest = 0;
    const schedule = [];
    // Extract only the date from transactionDate
    let transactionDate = new Date(
      memberDetails.memberDetails.memberDetails.branchManagerStatusUpdatedAt
    );

    // Extract week number and day of the week from dayOrderByBranchManager
    const [weekNumber, dayOfWeek] = dayOrderByBranchManager.split(",");

    // Map day of the week to a number (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
    const dayOfWeekMap = {
      Monday: 1,
      Tuesday: 2,
      Wednesday: 3,
      Thursday: 4,
      Friday: 5,
      Saturday: 6,
    };
    const targetDay = dayOfWeekMap[dayOfWeek];

    for (let month = 1; month <= tenureInMonths; month++) {
      const interest = balance * monthlyRate;
      const principal = emi - interest;
      beginingBalance = balance;
      balance -= principal;
      sumOfInterest += interest;

      // Calculate the EMI date for the current month
      const paymentDate = new Date(transactionDate);
      paymentDate.setMonth(transactionDate.getMonth() + month); // Add the current month to the transaction date
      // Find the nth occurrence of the target day in the month
      let count = 0;
      let currentDate = new Date(
        paymentDate.getFullYear(),
        paymentDate.getMonth(),
        1
      );

      while (currentDate.getMonth() === paymentDate.getMonth()) {
        if (currentDate.getDay() === targetDay) {
          count++;
          if (count === parseInt(weekNumber)) {
            paymentDate.setDate(currentDate.getDate());
            break;
          }
        }
        currentDate.setDate(currentDate.getDate() + 1);
      }

      schedule.push({
        month,
        emi,
        principal,
        interest,
        balance: balance > 0 ? balance : 0,
        emiDate: `${String(paymentDate.getDate()).padStart(2, "0")}/${String(
          paymentDate.getMonth() + 1
        ).padStart(2, "0")}/${paymentDate.getFullYear()}`, // Format as DD/MM/YYYY
        beginingBalance,
      });
    }
    setGeneratedSchedule(schedule);
    setTotalInterest(sumOfInterest);
  };

  return (
    <div>
      <div>
        <h1 className="section text-center">Repayment Schedule</h1>
        <div>
          <table
            className="table table-striped text-center table-bordered"
            style={{
              width: "100%",
              fontSize: "26px",
              borderCollapse: "collapse",
              border: "1.5px solid black",
            }}
          >
            <tbody>
              <tr className="section">
                <td
                  style={{
                    width: "30%",
                    border: "1.5px solid black",
                    padding: "2px",
                  }}
                >
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ width: "50%" }}>
                        <b>Customer Name</b>
                      </div>
                      <div style={{ width: "50%" }}>
                        {memberDetails.memberDetails.memberDetails.memberName}
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: "10px",
                      }}
                    >
                      <div style={{ width: "50%" }}>
                        <b>Branch Name</b>
                      </div>
                      <div style={{ width: "50%" }}>
                        {memberDetails.memberDetails.branchName}
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: "10px",
                      }}
                    >
                      <div style={{ width: "50%" }}>
                        <b>Rate of Interest</b>
                      </div>
                      <div style={{ width: "50%" }}>
                        {
                          memberDetails.memberDetails.proposedLoanDetails
                            .rateOfInterest
                        }
                        %
                      </div>
                    </div>
                  </div>
                </td>
                <td style={{ width: "20%", border: "1.5px solid black" }}>
                  <img
                    src={`${BASE_URL}/images/${memberDetails.memberDetails.memberDocuments.memberPhoto}`}
                    alt=""
                    style={{ width: "150px", height: "150px" }}
                  />
                </td>
                <td style={{ width: "20%", border: "1.5px solid black" }}>
                  <img
                    src={`${BASE_URL}/images/${memberDetails.memberDetails.nomineeDocuments.nomineePhoto}`}
                    alt=""
                    style={{ width: "150px", height: "150px" }}
                  />
                </td>
                <td
                  style={{
                    width: "30%",
                    border: "1.5px solid black",
                    padding: "2px",
                  }}
                >
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ width: "50%" }}>
                        <b>Customer ID</b>
                      </div>
                      <div style={{ width: "50%" }}>
                        {memberDetails.memberDetails.memberDetails.customerId}
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: "10px",
                      }}
                    >
                      <div style={{ width: "50%" }}>
                        <b>Loan Amount</b>
                      </div>
                      <div style={{ width: "50%" }}>
                        {
                          memberDetails.memberDetails.proposedLoanDetails
                            .loanAmount
                        }
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: "10px",
                      }}
                    >
                      <div style={{ width: "50%" }}>
                        <b>Tenure</b>
                      </div>
                      <div style={{ width: "50%" }}>
                        {
                          memberDetails.memberDetails.proposedLoanDetails
                            .tenureInMonths
                        }{" "}
                        months
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <div className="table-responsive">
            <table
              className="table table-striped text-center table-bordered"
              style={{
                fontSize: "26px",
                borderCollapse: "collapse",
                border: "1.5px solid black",
              }}
            >
              <thead className="primaryColor thead_sticky bg-primary">
                <tr className="section">
                  <th style={{ border: "1.5px solid black", padding: "0" }}>
                    S.No
                  </th>
                  <th style={{ border: "1.5px solid black", padding: "0" }}>
                    Repayment Date
                  </th>
                  <th style={{ border: "1.5px solid black", padding: "0" }}>
                    Principal
                  </th>
                  <th style={{ border: "1.5px solid black", padding: "0" }}>
                    Interest
                  </th>
                  <th style={{ border: "1.5px solid black", padding: "0" }}>
                    Total EMI
                  </th>
                  <th style={{ border: "1.5px solid black", padding: "0" }}>
                    Outstanding Balance
                  </th>
                </tr>
              </thead>
              <tbody>
                {generatedSchedule.map((item, index) => (
                  <tr key={index} className="section">
                    <td style={{ border: "1.5px solid black", padding: "0" }}>
                      {index + 1}
                    </td>
                    <td style={{ border: "1.5px solid black", padding: "0" }}>
                      {item.emiDate}
                    </td>
                    <td style={{ border: "1.5px solid black", padding: "0" }}>
                      {Math.round(item.principal)}
                    </td>
                    <td style={{ border: "1.5px solid black", padding: "0" }}>
                      {Math.round(item.interest)}
                    </td>
                    <td style={{ border: "1.5px solid black", padding: "0" }}>
                      {Math.round(item.emi)}
                    </td>
                    <td style={{ border: "1.5px solid black", padding: "0" }}>
                      {Math.round(item.balance)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JlgGeneratedEmiSchedule;
